import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CalendarClock, Lock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const YearCloseReminder = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const prevYear = new Date().getFullYear() - 1;
  const isJanuary = new Date().getMonth() === 0;

  useEffect(() => {
    if (!isJanuary || user?.role !== 'super_admin') return;
    if (sessionStorage.getItem(`yc-dismiss-${prevYear}`)) return;
    axios.get(`${API_URL}/api/finance/archives`).then((r) => {
      if (!(r.data.items || []).some((a) => a.year === prevYear)) setShow(true);
    }).catch(() => {});
  }, [isJanuary, user, prevYear]);

  if (!show) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 border border-amber-300 bg-amber-50 dark:bg-amber-900/15 rounded-lg p-3" data-testid="year-close-reminder">
      <CalendarClock className="h-5 w-5 text-amber-600" />
      <div className="flex-1 text-sm">
        <p className="font-medium">Happy new year! Financial year {prevYear} is still open.</p>
        <p className="text-muted-foreground text-xs">Close it to archive last year's records and start {prevYear + 1} afresh — everything stays accessible in the Year Archive.</p>
      </div>
      <Button size="sm" onClick={() => navigate(`/finance/archive?close=${prevYear}`)} data-testid="year-close-reminder-btn">
        <Lock className="h-3.5 w-3.5 mr-1" /> Close {prevYear} Now
      </Button>
      <Button size="sm" variant="ghost" onClick={() => { sessionStorage.setItem(`yc-dismiss-${prevYear}`, '1'); setShow(false); }} data-testid="year-close-reminder-dismiss">
        Later
      </Button>
    </div>
  );
};
